import { Screen } from '@bonanza-social/navigation';
import { MetaGame } from '../../components';
import { MetaGameScreenProps } from './MetaGameScreen.types';
import { memo } from 'react';

function MetaGameScreen({ route }: MetaGameScreenProps) {
  const { gameType } = route.params;

  return (
    <Screen paddingHorizontal="space-0">
      <MetaGame gameType={gameType} />
    </Screen>
  );
}

export default memo(MetaGameScreen);
